import { GameElementCategory } from "@shared/game-engine";

export enum GamePluginType {
  GAME_COMPONENT = "game-component",
}

export enum GamePluginStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

// Different subtypes of game plugins, for filtering
export type GamePluginSubtype = GameElementCategory;
